export const DEFAULT_THEMES = {
    Z_INDEX: { mobileStepper: 100, fab: 105, speedDial: 105, appBar: 110, drawer: 120, modal: 130, snackbar: 140, tooltip: 150 },
    APP_BAR: { width: 240, headerHeight: '0px', enableMenu: true, menuPosition: 'right', backPosition: 'left', enableBack: true },
    TOOL_BAR: { height: '0px' }
};

export const ENV_TYPES = {
    LOCAL: 'local',
    DEV: 'dev',
    PROD: 'prod'
};
export const SHARE_FLEX_IMAGES = 'https://d5j80r6ig58b5.cloudfront.net/img/137/s00137-70dfc8d0-9978-48be-a12f-e62684a02358';
export const GA_UTM_CAMPAIGN = 'ga_utm_campaign';
export const GA_UTM_MEDIUM = 'ga_utm_medium';
export const GA_UTM_SOURCE = 'ga_utm_source';
export const GA_CATEGORY = 'cathay-red-60-years';

export const APP_BAR_HEIGHT = `calc( var(--app-height) * 0 )`;
export const TOOLBAR_HEIGHT = `calc( var(--app-height) * 0 )`;
export const ANNOTATION = {
    Type: {
        INPUT: 'INPUT',
        ITEM_LIST: 'ITEM_LIST',
        DATE: 'DATE',
        OPTIONS: 'OPTIONS',
        ORDERER: 'ORDERER',
        BRANCH: 'BRANCH',
        STORE_SEVEN: 'STORE_SEVEN',
        STORE_FAMILY: 'STORE_FAMILY',
        COUPON: 'COUPON',
        POINT: 'POINT',
        CHECKBOX: 'CHECKBOX',
        RADIO_GROUP: 'RADIO_GROUP'
    },

    SystemKey: {
        PAYMENT: 'payment',
        DELIVERY: 'delivery',
        COUPON: 'coupon',
        POINT: 'point',
        ACCOUNT: 'account',
        INSTALLMENT_MONTH: 'installment_month',
        BRANCH: 'branch',
        ADDRESS: 'address',
        STORE_FAMILY: 'store_family',
        STORE_SEVEN: 'store_seven'
    },

    DateMode: {
        DATETIME: 'DATETIME',
        TIME: 'TIME',
        DATE: 'DATE',
        LUNAR: 'LUNAR'
    },
    PhoneVerifyState: {
        UNVERIFY: 'UNVERIFY',
        VERIFYING: 'VERIFYING',
        VERIFIED: 'VERIFIED'
    },
    PhoneVerifyStateText: {
        UNVERIFY: '發送驗證碼',
        VERIFYING: '驗證',
        VERIFIED: '已驗證'
    }
};

export const DATE_PARSE = {
    0: '日',
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六'
};

export const DEFAULT_TIME_SETTINGS = {
    PREVIEW_PERIOD: 1,
    PREVIEW_PERIOD_UNIT: 'M'
};

export const TIME_UNITS_KEYS = { WEEK: 'W', MONTH: 'M', DAY: 'd', HOUR: 'h', MINUTE: 'm' };

export const TIME_UNIT = {
    MINUTE: { abbr: 'm', key: 'minute', label: '分', format: ['YYYY-MM-DD HH:mm', 'YYYY/MM/DD HH:mm'] },
    HOUR: { abbr: 'h', key: 'hour', label: '時', format: ['YYYY-MM-DD HH:00', 'YYYY/MM/DD HH:00'] },
    DAY: { abbr: 'd', key: 'day', label: '天', format: ['YYYY-MM-DD', 'YYYY/MM/DD'] },
    WEEK: { abbr: 'w', key: 'week', label: '週', format: ['YYYY-MM-', 'YYYY/MM'] },
    MONTH: { abbr: 'M', key: 'month', label: '月', format: ['YYYY-MM-', 'YYYY/MM'] }
};

export const TIME_FORMATS = {
    DATE: 'YYYY-MM-DD',
    TIME: 'HH:mm',
    TWELVE_TIME: 'h:mm',
    DATE_TIME: 'YYYY-MM-DD HH:mm'
};

export const APPOINTMENT_STATUS = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    CANCEL: 'CANCEL'
};

export const SCHEDULE_EVENT_GROUP_STATUS = {
    ON: 'ON',
    OFF: 'OFF'
};

export const APPOINTMENT_DISABLE_SIGNUP_SETTINGS = {
    closeSignupTime: 1,
    closeSignupTimeUnit: 'h'
};

export const TimeUnit = {
    d: '天',
    h: '小時',
    m: '分鐘'
};

export const VerifyState = {
    UNVERIFY: 'UNVERIFY',
    VERIFYING: 'VERIFYING',
    VERIFIED: 'VERIFIED'
};

export const VerifyStateText = {
    UNVERIFY: '驗證',
    VERIFYING: '驗證',
    VERIFIED: '已驗證'
};

export const ANDROID_VERSION = 10;
export const ISO_VERSION = 11;

export const HIDE_MUSIC_PLAYER_ROUTES = ['book', 'feedback'];
export const I_PHONE_MODEL = ['2G/3G/3GS', '4/4S', '5/5S/5C/SE', '6/6S/7/8/SE2', '6Plus/6S Plus/7Plus/8Plus'];
